import Helmet from "react-helmet";

const HeadTags = (props) => {
  const {
    title = "Universal 57",
    metaDescription = "Universal 57",
  } = props;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={metaDescription} />
      <meta name="title" key="title" content={title} />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="ru_RU" />
      <meta property="og:type" content="article" />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content="https://graf-yagoda.ru/logo.svg" />  
      <meta property="og:url" content={document.URL}></meta>
    </Helmet>
  );
};
export default HeadTags;